import { useCallback, useEffect, useMemo, useState } from 'react';
import { useUniversityContext } from '@/context';
import { Flex } from '../../common';

export default function ServicesStatus() {
  const { universities, loading } = useUniversityContext();
  const [_results, setResults] = useState({});

  const items = useMemo(() => {
    return universities.map(({ universityURL, ...u }) => {
      return {
        ...u,
        universityURL: Array.isArray(universityURL) ? universityURL : [universityURL]
      };
    });
  }, [universities, loading]);

  const execServicesCheck = useCallback(async () => {
    setResults([]);
    items.forEach(async _item => {
    });
  }, [setResults]);

  useEffect(() => {
    execServicesCheck();
  }, [setResults, universities]);

  return (
    <Flex className="text-end ltr font-sans" direction="column">
      Service Content {items.length}
      {items.map((item, index) => (
        <div key={index}>
          {item.universityLabel}
          <div>
            {item.universityURL.map((_url, urlIndex) => (
              <div className="text-sm" key={urlIndex}>Server {urlIndex + 1}: </div>
            ))}
          </div>
        </div>
      ))}
    </Flex>
  );
}
